<div fxLayout="column" style="padding:15px;" fxLayoutAlign="center center center">

  <mat-card ngStyle.gt-lg="width:96%;" ngStyle.lg="width:96%;" ngStyle.lt-lg="width:100%;">
    <mat-card-title>
      <div fxLayout="row">

        <div fxFlex="grow" class="pageTitle" style="font-size: 22px;" fxLayoutAlign="start center center">Βιογραφικά</div>

        <div fxLayoutGap="5px" fxLayoutAlign="end center center">
          <button mat-raised-button
                  style="color:white; background-color: #00bfa5; font-family: 'Century Gothic', sans-serif"
                  matTooltip="Δημιουργία νέας δήλωσης" (click)="navigateToResumeCreator()">
            Δημιουργία νέας αίτησης βιογραφικού
          </button>
        </div>
      </div>

    </mat-card-title>
    <mat-card-content fxLayout="column">
      <mat-tab-group #tabs mat-stretch-tabs>
        <mat-tab>
          <ng-template mat-tab-label>
            <div fxLayout="row" style="font-family: 'Century Gothic', sans-serif">
             Φόρμες Βιογραφικών
            </div>
          </ng-template>

          <div style="margin-top: 50px;">
            <app-resumes-table [isReport]="false"></app-resumes-table>
          </div>
        </mat-tab>

        <mat-tab>
          <ng-template mat-tab-label>
            <div fxLayout="row" style="font-family: 'Century Gothic', sans-serif">
              Αναφορές Βιογραφικών
            </div>
          </ng-template>
          <div style="margin-top: 50px;">
            <app-resumes-table [isReport]="true"></app-resumes-table>
          </div>
        </mat-tab>
      </mat-tab-group>

    </mat-card-content>
  </mat-card>
</div>
